import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ArrowRightIcon, CheckCircleIcon, DownloadIcon, BeakerIcon } from 'lucide-react';
const ProductPage = () => {
  return <div className="min-h-screen bg-white" data-id="element-477" data-mp="xllk76rvd8ub">
      <Navbar data-id="element-478" data-mp="xopveo3r54uh" />
      {/* Hero Section */}
      <div className="relative bg-white py-16 md:py-24" data-id="element-479" data-mp="tmcr844nlezt">
        <div className="absolute inset-0 overflow-hidden opacity-5" data-id="element-480" data-mp="5vpgzc79mda3">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1530026186672-2cd00ffc50fe?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center" data-id="element-481" data-mp="5vz8x5bveuif"></div>
        </div>
        <div className="container mx-auto px-4 max-w-7xl relative" data-id="element-482" data-mp="exp14ddktxh9">
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-483" data-mp="9w9c6a8a36tl">
            <div className="md:w-1/2 md:pr-8" data-id="element-484" data-mp="1qb17auwt6s6l">
              <h1 className="text-4xl md:text-5xl font-bold mb-4 text-teal-800" data-id="element-485" data-mp="1q9zlpwi62nam">
                Reset Your Gut. Reset Your Health.
              </h1>
              <p className="text-lg md:text-xl mb-8 text-gray-700" data-id="element-486" data-mp="1cootu4u0xlux">
                A science-backed program designed to restore microbial balance,
                disrupt harmful biofilms, and strengthen your gut barrier.
                Backed by research at the California Institute for Microbiome
                Research (CalMiR) and validated through the Ukweli Certified™
                program.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-487" data-mp="t17l678szn5c">
                <button className="bg-teal-800 text-white hover:bg-teal-700 transition-colors duration-300 px-6 py-3 rounded-md font-medium flex items-center" data-id="element-488" data-mp="sybr4u02tim6">
                  Start Your Reset <ArrowRightIcon className="ml-2" size={18} data-id="element-489" data-mp="12x154bouqix5" />
                </button>
                <button className="bg-white text-teal-800 border border-teal-800 hover:bg-teal-50 transition-colors duration-300 px-6 py-3 rounded-md font-medium flex items-center" data-id="element-490" data-mp="17qnadisorkix">
                  Learn the Science <BeakerIcon className="ml-2" size={18} data-id="element-491" data-mp="f76tfxg9r0eh" />
                </button>
              </div>
            </div>
            <div className="md:w-1/2 flex justify-center mt-8 md:mt-0" data-id="element-492" data-mp="75zbunxjxo93">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4GfsjSQSUFi6K4HMQubmAL/ddv.png" alt="CalBiome Microbiota Reset Protocol bottle" className="max-w-full rounded-lg shadow-lg" data-id="element-493" data-mp="35yuovj2iyyc" />
            </div>
          </div>
        </div>
      </div>
      {/* Why Reset Section */}
      <div className="bg-gray-50 py-16" data-id="element-494" data-mp="3gda0v29z2ol2">
        <div className="container mx-auto px-4 max-w-7xl" data-id="element-495" data-mp="3gebo0549j1j5">
          <div className="max-w-3xl mx-auto" data-id="element-496" data-mp="3uci5iaowmown">
            <h2 className="text-3xl font-bold mb-8 text-center text-teal-800" data-id="element-497" data-mp="3uecqfp06eh0q">
              <span className="text-teal-600" data-id="element-498" data-mp="3pcnb3x5x7h6u">🌟</span> Why Reset Your
              Microbiome?
            </h2>
            <div className="space-y-6" data-id="element-499" data-mp="19l96vx3c69xf">
              <div className="flex items-start gap-4 bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-500" data-mp="19odi3ef7y5xl">
                <div className="mt-1 text-teal-600 flex-shrink-0" data-id="element-501" data-mp="2mkt6hsywcau0">
                  <CheckCircleIcon size={24} data-id="element-502" data-mp="2rk5vokd8ptzr" />
                </div>
                <div data-id="element-503" data-mp="2rlh08meif5rx">
                  <p className="font-medium text-gray-900" data-id="element-504" data-mp="2rht6pn92ejd7">
                    80% of the immune system lives in the gut.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4 bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-505" data-mp="2illitzud2ejg">
                <div className="mt-1 text-teal-600 flex-shrink-0" data-id="element-506" data-mp="3ab6rx0mz7bfm">
                  <CheckCircleIcon size={24} data-id="element-507" data-mp="3achvp0gf8j6q" />
                </div>
                <div data-id="element-508" data-mp="2wiqwom0bghp9">
                  <p className="font-medium text-gray-900" data-id="element-509" data-mp="2wh606qufyoor">
                    Biofilms protect harmful bacteria, making them resistant to
                    probiotics.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4 bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-510" data-mp="3tz63gdpd6mm3">
                <div className="mt-1 text-teal-600 flex-shrink-0" data-id="element-511" data-mp="25dmoxw5xczd0">
                  <CheckCircleIcon size={24} data-id="element-512" data-mp="20d8nwy2qqpoh" />
                </div>
                <div data-id="element-513" data-mp="20g37yohue8hd">
                  <p className="font-medium text-gray-900" data-id="element-514" data-mp="1wbn3mrnvn949">
                    Modern diets and stress disrupt the balance of good
                    bacteria.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4 bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-515" data-mp="2o29qi4ow76lu">
                <div className="mt-1 text-teal-600 flex-shrink-0" data-id="element-516" data-mp="2k3u6m9o3yecn">
                  <CheckCircleIcon size={24} data-id="element-517" data-mp="2f9py3lz71y9g" />
                </div>
                <div data-id="element-518" data-mp="2acg19l9h6kbl">
                  <p className="font-medium text-gray-900" data-id="element-519" data-mp="2aav7vyywd7fb">
                    The Microbiota Reset Protocol is designed to help you
                    rebuild from the inside out.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* What's Inside Section */}
      <div className="py-16 bg-white" data-id="element-520" data-mp="3adun0xt4prcx">
        <div className="container mx-auto px-4 max-w-7xl" data-id="element-521" data-mp="3fabarqwf23ph">
          <h2 className="text-3xl font-bold mb-12 text-center text-teal-800" data-id="element-522" data-mp="3fcxh5n7kmd64">
            <span className="text-teal-600" data-id="element-523" data-mp="3k8ctgapxk10f">🔬</span> What's Inside the Protocol
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-524" data-mp="3od2o5w8ur9jr">
            <div className="bg-teal-50 p-8 rounded-lg" data-id="element-525" data-mp="3tavqge71bjer">
              <h3 className="text-xl font-bold mb-4 text-teal-800" data-id="element-526" data-mp="3tacb958rr94f">
                Phase 1 – Reset & Cleanse
              </h3>
              <ul className="space-y-4" data-id="element-527" data-mp="6v19um49j4ja">
                <li className="flex items-start gap-3" data-id="element-528" data-mp="6w2of0khm95r">
                  <div className="text-teal-600 mt-1 flex-shrink-0" data-id="element-529" data-mp="bu4g29vzbgsu">
                    <CheckCircleIcon size={20} data-id="element-530" data-mp="btb50wpzm54w" />
                  </div>
                  <p className="text-gray-700" data-id="element-531" data-mp="fwr5k456gpmv">
                    N-acetylcysteine (NAC) for biofilm disruption.
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-532" data-mp="2gxxcjuqi8n3m">
                  <div className="text-teal-600 mt-1 flex-shrink-0" data-id="element-533" data-mp="2gygrr3orsxdy">
                    <CheckCircleIcon size={20} data-id="element-534" data-mp="2cx52x0dq0g6t" />
                  </div>
                  <p className="text-gray-700" data-id="element-535" data-mp="2qnqoiwuk748e">
                    Tomato phytonutrients for natural antimicrobial support.
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-536" data-mp="2lvpe7ggybnl0">
                  <div className="text-teal-600 mt-1 flex-shrink-0" data-id="element-537" data-mp="30l512ldd38vf">
                    <CheckCircleIcon size={20} data-id="element-538" data-mp="2vmtrmbqzb0dq" />
                  </div>
                  <p className="text-gray-700" data-id="element-539" data-mp="2vmjxcbywi728">
                    Bacillus laterosporus spores to prepare for recolonization.
                  </p>
                </li>
              </ul>
            </div>
            <div className="bg-teal-50 p-8 rounded-lg" data-id="element-540" data-mp="34lf5vupf3t8p">
              <h3 className="text-xl font-bold mb-4 text-teal-800" data-id="element-541" data-mp="1f9mtrog5dc2a">
                Phase 2 – Rebuild & Restore
              </h3>
              <ul className="space-y-4" data-id="element-542" data-mp="1abbhl72dqpgw">
                <li className="flex items-start gap-3" data-id="element-543" data-mp="3lx3vogtko8gj">
                  <div className="text-teal-600 mt-1 flex-shrink-0" data-id="element-544" data-mp="3lxm1o561e11n">
                    <CheckCircleIcon size={20} data-id="element-545" data-mp="3quvpxhhow6nw" />
                  </div>
                  <p className="text-gray-700" data-id="element-546" data-mp="3d5212z66pme6">
                    Evidence-based probiotic blends for gut recolonization.
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-547" data-mp="3h411c6gz0uza">
                  <div className="text-teal-600 mt-1 flex-shrink-0" data-id="element-548" data-mp="335b48qu5ivax">
                    <CheckCircleIcon size={20} data-id="element-549" data-mp="3855yn4d4y30q" />
                  </div>
                  <p className="text-gray-700" data-id="element-550" data-mp="383cqfkmvjaqm">
                    Cofactor nutrients (B vitamins, selenium, magnesium) to
                    optimize microbial metabolism.
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-551" data-mp="seb9md8th61n">
                  <div className="text-teal-600 mt-1 flex-shrink-0" data-id="element-552" data-mp="set35243h65v">
                    <CheckCircleIcon size={20} data-id="element-553" data-mp="wg6c3l2hhph0" />
                  </div>
                  <p className="text-gray-700" data-id="element-554" data-mp="3gbxj9wn2gus2">
                    Structured daily guide for diet and lifestyle support.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* Why CalBiome Section */}
      <div className="bg-gray-50 py-16" data-id="element-555" data-mp="36k19vpfj5i8j">
        <div className="container mx-auto px-4 max-w-7xl" data-id="element-556" data-mp="31nkp957jhm07">
          <h2 className="text-3xl font-bold mb-8 text-center text-teal-800" data-id="element-557" data-mp="31kye6vlfwod8">
            <span className="text-teal-600" data-id="element-558" data-mp="2xn0qjx7biaby">✅</span> Why CalBiome?
          </h2>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-559" data-mp="2slbhgn3no6qi">
            <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-560" data-mp="2nn9xlzyeo3dz">
              <h3 className="text-xl font-bold mb-3 text-teal-800" data-id="element-561" data-mp="2iof3i1uzmsek">
                Science-First
              </h3>
              <p className="text-gray-700" data-id="element-562" data-mp="lw58bajy3ewt">
                Developed from peer-reviewed research at CalMiR.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-563" data-mp="gupkjaqduuaq">
              <h3 className="text-xl font-bold mb-3 text-teal-800" data-id="element-564" data-mp="pbzy635b0f3o">
                Certified Trust
              </h3>
              <p className="text-gray-700" data-id="element-565" data-mp="y6eco3i0fllq">
                Independently validated through the Ukweli Certified™ program.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-566" data-mp="134ftsivvlauk">
              <h3 className="text-xl font-bold mb-3 text-teal-800" data-id="element-567" data-mp="6h1i0z16222v">
                Consumer-Ready
              </h3>
              <p className="text-gray-700" data-id="element-568" data-mp="ffmwahzluuxu">
                Designed for real-world use, not just lab experiments.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Evidence Section */}
      <div className="py-16 bg-white" data-id="element-569" data-mp="1qvbk1bkonxzp">
        <div className="container mx-auto px-4 max-w-7xl" data-id="element-570" data-mp="1qua3wsot8lb4">
          <h2 className="text-3xl font-bold mb-8 text-center text-teal-800" data-id="element-571" data-mp="1vtda4ggj0xko">
            <span className="text-teal-600" data-id="element-572" data-mp="21tw8asqyknzq">📊</span> Evidence That Matters
          </h2>
          <div className="max-w-3xl mx-auto space-y-6" data-id="element-573" data-mp="21s1wq51ku88b">
            <div className="flex items-start gap-4" data-id="element-574" data-mp="26roaqgp8bsi6">
              <div className="mt-1 text-teal-600 flex-shrink-0" data-id="element-575" data-mp="2bjo9w6xh6hdp">
                <CheckCircleIcon size={24} data-id="element-576" data-mp="2bkhep2cviwt7" />
              </div>
              <p className="text-gray-700" data-id="element-577" data-mp="2fk82cx73swti">
                In vitro studies show NAC + tomato phytonutrients disrupt
                pathogenic biofilms.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-578" data-mp="1ntbq9ysvaw7a">
              <div className="mt-1 text-teal-600 flex-shrink-0" data-id="element-579" data-mp="1nw7prrkd5sxu">
                <CheckCircleIcon size={24} data-id="element-580" data-mp="1ruxbq8jgwit3" />
              </div>
              <p className="text-gray-700" data-id="element-581" data-mp="1wujko5s9jcw3">
                Animal studies demonstrate improved gut barrier integrity and
                immune signaling.
              </p>
            </div>
            <div className="flex items-start gap-4" data-id="element-582" data-mp="389os1n3c9zm1">
              <div className="mt-1 text-teal-600 flex-shrink-0" data-id="element-583" data-mp="388dp1phpwvvz">
                <CheckCircleIcon size={24} data-id="element-584" data-mp="3ie55yax9d6n7" />
              </div>
              <p className="text-gray-700" data-id="element-585" data-mp="3ifq4ebmp19qc">
                Pilot human trials suggest reduced inflammation markers and
                improved focus, mood, and digestion.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Who It's For Section */}
      <div className="bg-gray-50 py-16" data-id="element-586" data-mp="34ke83zsw3b7b">
        <div className="container mx-auto px-4 max-w-7xl" data-id="element-587" data-mp="2znx9gbo2defz">
          <h2 className="text-3xl font-bold mb-8 text-center text-teal-800" data-id="element-588" data-mp="2zlb2ad5350ya">
            <span className="text-teal-600" data-id="element-589" data-mp="2umq1abi0ed8s">🌍</span> Who It's For
          </h2>
          <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-590" data-mp="2pq9af9jfdks0">
            <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-591" data-mp="2lnwa50ng6f2m">
              <h3 className="text-lg font-bold mb-3 text-teal-800" data-id="element-592" data-mp="ny4nydkp3foo">
                Digestive Issues
              </h3>
              <p className="text-gray-700" data-id="element-593" data-mp="jxksrfjomm56">
                Individuals with IBS, bloating, food sensitivity.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-594" data-mp="2dd5oqxxn89dw">
              <h3 className="text-lg font-bold mb-3 text-teal-800" data-id="element-595" data-mp="24ek6l3w32wdn">Recovery</h3>
              <p className="text-gray-700" data-id="element-596" data-mp="24ch61pxb1kuo">
                Those recovering from antibiotic use or gut dysbiosis.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-597" data-mp="2w6jbwgv47biy">
              <h3 className="text-lg font-bold mb-3 text-teal-800" data-id="element-598" data-mp="3139rz46x674d">
                Wellness Seekers
              </h3>
              <p className="text-gray-700" data-id="element-599" data-mp="2n4ib5a0oa7cj">
                People seeking systemic wellness benefits — energy, focus,
                immunity.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Final CTA Section */}
      <div className="py-16 bg-teal-800 text-white" data-id="element-600" data-mp="1gozn8jw0px3u">
        <div className="container mx-auto px-4 max-w-7xl" data-id="element-601" data-mp="1gmmwpic72ef6">
          <div className="max-w-3xl mx-auto text-center" data-id="element-602" data-mp="186nyxo3ztrtp">
            <h2 className="text-3xl font-bold mb-8" data-id="element-603" data-mp="1463zgdvy6c4e">
              <span className="text-teal-300" data-id="element-604" data-mp="145khix6arnqd">🚀</span> Get Started
            </h2>
            <div className="flex flex-wrap gap-4 justify-center" data-id="element-605" data-mp="1i4tyhz2bulve">
              <button className="bg-white text-teal-800 hover:bg-teal-50 transition-colors duration-300 px-6 py-3 rounded-md font-medium" data-id="element-606" data-mp="1d71ui6oer9au">
                Buy Now – Microbiota Reset Protocol
              </button>
              <button className="bg-transparent border border-white text-white hover:bg-white/10 transition-colors duration-300 px-6 py-3 rounded-md font-medium flex items-center" data-id="element-607" data-mp="kimqef6tebea">
                Download Program Guide{' '}
                <DownloadIcon className="ml-2" size={18} data-id="element-608" data-mp="ufitg5dy25bg" />
              </button>
              <button className="bg-transparent border border-white text-white hover:bg-white/10 transition-colors duration-300 px-6 py-3 rounded-md font-medium flex items-center" data-id="element-609" data-mp="6py7reqeotyh">
                Explore the Research <BeakerIcon className="ml-2" size={18} data-id="element-610" data-mp="316p4975xai8f" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer data-id="element-611" data-mp="364yzfhrndiu1" />
    </div>;
};
export default ProductPage;